import { defineFieldTypeTemplate } from '../define';

export default defineFieldTypeTemplate({
	type: 'primitive',
	id: 'text',
	name: '$t:field_types.text.name',
	description: '$t:field_types.text.description',
	icon: 'lucide:a-large-small',
	sort: 200,
	keywords: ['string', 'varchar', 'text'],
	supportedPrimitiveTypes: ['string'],
});
